export const baseAppOrder = {
	app_order_id: "",
	code: "",
	internal_code: "",
	business_id: "",
	application_order_date: "",
	start_time: "",
	end_time: "",
	// harvest_date: "",
	machinery_id: "",
	machinery_integer: false,
	calibration: "",
	tractors: "",
	application_orders_phenological_state_id: "",
	text_phenological_state: "",
	observations: "",
	temperature: "20",
	wind: "10",
	wetness: "50",
	application_order_type_id: 0,
	application_order_type_id_customer: "",
	// Nuevo
	specie: "",
	estate_id: "",
	estate_parent_id: "",
	categories: [],
	species: [],
	varieties: [],
	quarters: [],
	business_centers_parents: [],
	business_centers: [],
	// Nuevo
	machineries: [],
	items: [],
	signatures: [],
	documents: [],
	irrigation_id: [],
	show_division: false,
	all_product: "customer",
};

export const baseItem = {
	application_orders_objetives_id: "",
	product_id: "",
	active_ingredient_id: "",
	active_ingredients: "",
	aptitudes: "",
	reingreso: "",
	color_tag: "",
	protection_days: "",
	lack_days: "",
	dose_100L: "",
	dose_ha: "",
	dose_machinery: "",
	quantity_machinery: "",
	quantity: "",
	product_options: [],
};

export const rangeSelectorsValues = {
	minTemp: -4,
	maxTemp: 45,
	minWind: 0,
	maxWind: 100,
	minWetness: 0,
	maxWetness: 100,
};

export const customStyles = {
	control: (base, state) => ({
		...base,
		background: "#f3f3f3",
		border: "none",
		height: "1px",
		boxShadow: state.isFocused ? null : null,
	}),
	menuPortal: (base) => ({
		...base,
		zIndex: 9999,
	}),
};

export const baseUnitCreate = [
	{
		value: "c1",
		label: "cc",
	},
	{
		value: "c1000",
		label: "L",
	},
	{
		value: "c1000000",
		label: "KL",
	},
	{
		value: "g1",
		label: "g",
	},
	{
		value: "g1000",
		label: "Kg",
	},
	{
		value: "g1000000",
		label: "Tn",
	},
];
